import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=dbe4e11c&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=dbe4e11c&lang=less&scoped=true&"
import style1 from "./Comment.vue?vue&type=style&index=1&id=dbe4e11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe4e11c",
  null
  
)

export default component.exports